export default __webpack_public_path__ + "static/media/panel-bg.f500e0f7.png";